<template>
    <div class="col-group">
        <TaxinummerLink date="Januari 2016" nummer="56" />
        <TaxinummerLink date="Februari 2016" nummer="57" />
        <TaxinummerLink date="Maart 2016" nummer="58" />
        <TaxinummerLink date="April 2016" nummer="59" />
        <TaxinummerLink date="Mei 2016 " nummer="60" />
        <TaxinummerLink date="Juni 2016 " nummer="61" />
        <TaxinummerLink date="Juli-Augustus 2016 " nummer="62" />
        <TaxinummerLink date="September 2016" nummer="63" />
        <TaxinummerLink date="Oktober 2016" nummer="64" />
        <TaxinummerLink date="November 2016" nummer="65" />
        <TaxinummerLink date="December 2016" nummer="66" />
    </div>
</template>

<script>
import TaxinummerLink from '@/components/TaxinummerLink';

export default{
    name: 'magazine-2016',
    components: {
        'TaxinummerLink': TaxinummerLink,
    }
}
</script>
